import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Stack, Text } from '@sixui/ui';
import { colorSchemeTokens } from '@sixui/ui/themes/base/colorScheme.stylex';
import stylex from '@stylexjs/stylex';
import { useTranslation } from 'react-i18next';

import type { ITableRowProps } from '~/components/molecules/Table';
import type { IPoll, IPollVote } from '~/lib/api/modules/Polls';
import { Empty } from '~/components/atoms/Empty';
import { UserAvatar } from '~/components/atoms/UserAvatar';
import { Table } from '~/components/molecules/Table';
import { parseUserInfo } from '~/helpers/parseUserInfo';

export type IPollVoteListItemProps = ITableRowProps & {
  poll: IPoll;
  vote: IPollVote;
};

const styles = stylex.create({
  empty: {
    color: colorSchemeTokens.outlineVariant,
  },
});

export const PollVoteListItem: React.FC<IPollVoteListItemProps> = (props) => {
  const { poll, vote, ...other } = props;
  const { t } = useTranslation();
  const userInfo = vote.user ? parseUserInfo(vote.user) : undefined;

  return (
    <Table.Row {...other}>
      <Stack as={Table.Body} horizontal gap={3}>
        <UserAvatar user={vote.user} />
        <Stack gap={1}>
          <Text variant="title" size="sm">
            {userInfo ? userInfo?.fullName : t('common.anonymous')}
          </Text>
        </Stack>
      </Stack>

      {poll.options?.map((option, optionIndex) => (
        <Stack as={Table.Body} key={optionIndex}>
          {vote.votes?.includes(option.id) ? (
            <div>
              <FontAwesomeIcon icon={faCheck} />
            </div>
          ) : (
            <Empty sx={styles.empty} />
          )}
        </Stack>
      ))}
    </Table.Row>
  );
};
